// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__NLtqK","tab":"styles_tab__gOTsW","activeTab":"styles_activeTab__L4prh","disabledTab":"styles_disabledTab__5q_8S","logOut":"styles_logOut__PUiIb"};